import { api } from '@services';
import { customActions_universal } from '@redux/actions';

const generateType = (actionType = 'CUSTOM', reducer = 'ORGANISM/LOGIN') => `${reducer}/${actionType}`;

export const sendOtp = (onOkCB = null) => {
	return async (dispatch, getState) => {
		const { phone } = getState().organism.login.sendOtp;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.login,
					render: 'checkOtp',
					sendOtp: {
						...getState().organism.login.sendOtp,
						$send: res.data,
					},
				},
			});

			if (onOkCB) onOkCB();
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.login,
					sendOtp: {
						...getState().organism.login.sendOtp,
						_send: status,
					},
				},
			});
		};

		api.$otp_send_login({ onOK, onStatus }, { cellphone: Number(phone) });
	};
};

export const checkOtp = (onOkCB = null) => {
	return async (dispatch, getState) => {
		const { phone } = getState().organism.login.sendOtp;
		const { otp } = getState().organism.login.checkOtp;

		const onOK = async (res) => {
			await dispatch(customActions_universal.account.login(res.info));
			if (onOkCB) onOkCB();
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.login,
					checkOtp: {
						...getState().organism.login.checkOtp,
						_check: status,
					},
				},
			});
		};

		// const onFail = async (data) => {
		// 	await dispatch({
		// 		type: generateType('CUSTOM'),
		// 		payload: {
		// 			...getState().organism.login,
		// 			render: 'error',
		// 		},
		// 	});
		// };

		api.$otp_check_login(
			{ onOK, onStatus, okMessage: 'ورود موفقیت آمیز' },
			{ cellphone: Number(phone), code: Number(otp), type: 'L' },
		);
	};
};
